import { makeStyles } from "$components/mui-styles";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
} from "@material-ui/core";
import React from "react";
import { PRIVATE_INSURANCE } from "./formConstants";
import { InsurerDetails } from "./InsurerDetails";
import { InsurerDetailsActions } from "./InsurerDetailsActions";
import { InsurerSummary } from "./InsurerSummary";
import type { InsurerAccordionProps, InsurerSummaryProps } from "./types";

const useStyles = makeStyles({
  root: {
    "&.Mui-focused": {
      backgroundColor: "inherit",
    },
  },
});

export const findAddedInsurer = (insurers, name) => {
  return insurers.find((i) => i.name === name);
};

export const InsurerAccordion = ({
  insurer,
  index,
  handleRemoveInsurer,
  insurers,
  invoiceId,
}: InsurerAccordionProps): React.ReactElement => {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState<boolean>(true);
  const insurerName =
    insurer.type !== PRIVATE_INSURANCE
      ? insurer.insuranceDetails?.name
      : insurer?.name;

  const invoiceSummaryProps: InsurerSummaryProps = {
    index,
    expanded,
    setExpanded,
    insuranceName: insurerName,
  };

  const addedInsurerProperties = findAddedInsurer(
    insurers,
    insurer?.name,
  )?.properties;

  const deleteInsurer = () => {
    handleRemoveInsurer(index);
  };
  return (
    <Accordion expanded={expanded} elevation={0}>
      <AccordionSummary classes={{ root: classes.root }}>
        <InsurerSummary {...invoiceSummaryProps} />
      </AccordionSummary>
      <AccordionDetails>
        <Grid container>
          <Grid item xs={12}>
            <InsurerDetails
              index={index}
              insurerType={insurer?.type}
              insurerProperties={insurer?.properties || addedInsurerProperties}
            />
            <InsurerDetailsActions deleteInsurer={deleteInsurer} />
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};
